import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Select, { components } from "react-select";
import { useSelector } from "react-redux";
import { formatAmount } from "../../../../Utils/CommonUtils";
import { useQuoteMemberOptions } from "../Hook/useQuoteOptions";
import NewMemberModal from "./NewMemberModal";
import "../../Orders/Order.scss";

// "Add New Member" is pinned under the member list inside the dropdown
const MenuList = (props) => (
  <components.MenuList {...props}>
    {props.children}
    <div
      className="d-flex align-items-center gap-2 px-3 py-2 text-primary border-top"
      style={{ cursor: "pointer" }}
      onMouseDown={(e) => {
        e.preventDefault();
        props.selectProps.onAddNewMember();
      }}
    >
      <i className="ri-add-line"></i> Add New Member
    </div>
  </components.MenuList>
);

const ConvertToOrderModal = ({ show, onHide, onNext, isConverting }) => {
  const detailsData = useSelector(
    (state) => state.order.selectedOrders.detailsData
  );
  const formState = useSelector((state) => state.common.formRendererState);
  const productAttributeData = useSelector(
    (state) => state.order.productAttributeData
  );
  const productVariantModalState = useSelector(
    (state) => state.order.productVariantModalState
  );

  const agId = detailsData.ag_id || formState.ag_id;
  const [memberId, setMemberId] = useState("");
  const [newMember, setNewMember] = useState(null);
  const [showNewMember, setShowNewMember] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const { data: memberOptions = [], refetch } = useQuoteMemberOptions(
    agId,
    show
  );

  useEffect(() => {
    if (show) {
      setMemberId("");
      setNewMember(null);
      setSubmitted(false);
    }
  }, [show]);

  // Include a just-created member until the list refetch brings it back
  const options =
    newMember && !memberOptions.some((itm) => itm.value === newMember.value)
      ? [...memberOptions, newMember]
      : memberOptions;

  const productNames = (productAttributeData || [])
    .map((child) => child.name)
    .join(" • ");
  const amount = detailsData.gross_amount || productVariantModalState?.finalPremium;

  const handleMemberCreated = (member) => {
    setShowNewMember(false);
    setNewMember(member);
    setMemberId(member.value);
    refetch();
  };

  const handleNext = () => {
    setSubmitted(true);
    if (!memberId) return;
    onNext(memberId);
  };

  return (
    <>
      <Modal
        show={show && !showNewMember}
        onHide={onHide}
        centered
        backdrop="static"
        keyboard={false}
        className="border-0"
        modalClassName="modal fade zoomIn"
        size="lg"
      >
        <Form className="attributes-container">
          <Modal.Header className="p-3 bg-info-subtle" closeButton>
            <strong>Convert to Order</strong>
          </Modal.Header>
          <Modal.Body className="modal-body">
            <div className="border rounded p-3 mb-3 bg-light">
              <div className="d-flex justify-content-between align-items-center">
                <strong>
                  <i className="ri-file-text-line me-1"></i>
                  Quote Details: #{detailsData.code || "-"}
                </strong>
                <span className="payment-success">
                  Amount: {amount ? formatAmount(amount, null, null, "lakh") : "-"}
                </span>
              </div>
              <div className="mt-2">
                <span className="text-muted">Product: </span>
                {productNames || "-"}
              </div>
            </div>

            <Form.Group
              className="mb-3"
              style={{ minWidth: "280px", maxWidth: "360px" }}
            >
              <Form.Label>
                Select member<span className="text-danger">*</span>
              </Form.Label>
              <Select
                placeholder="--Select--"
                options={options}
                value={options.find((itm) => itm.value === memberId) || null}
                onChange={(e) => setMemberId(e ? e.value : "")}
                components={{ MenuList }}
                onAddNewMember={() => setShowNewMember(true)}
                menuPortalTarget={document.body}
                menuPlacement="auto"
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }) }}
                className={submitted && !memberId ? "is-invalid" : ""}
              />
              {submitted && !memberId && (
                <div className="invalid-feedback">This field is required</div>
              )}
              <div
                className="text-primary mt-3"
                style={{ cursor: "pointer", width: "fit-content" }}
                onClick={() => setShowNewMember(true)}
              >
                <i className="ri-add-line me-1"></i>Add New Member
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            <Button type="button" className="primary-outline" onClick={onHide}>
              Cancel
            </Button>
            <Button type="button" onClick={handleNext} disabled={isConverting}>
              {isConverting ? "Converting..." : "Next"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <NewMemberModal
        show={showNewMember}
        onHide={() => setShowNewMember(false)}
        onCreated={handleMemberCreated}
      />
    </>
  );
};

export default ConvertToOrderModal;
